<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="formData" :inline="true" size="mini" label-width="100px">
        <el-form-item label="产品编码:" prop="productCode">
          <el-input v-model="formData.productCode" placeholder="请输入产品编码" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="产品名称:" prop="productName">
          <el-input v-model="formData.productName" placeholder="请输入产品名称" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="产品型号:" prop="productBigModel" v-if="!isShowProductSales">
          <el-input v-model="formData.productBigModel" placeholder="请输入产品型号" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="平台名称:" prop="platformName">
          <el-select v-model="formData.platformName" multiple collapse-tags filterable>
            <el-option v-for="(item,index) in platformNameList" :label="item.platformname" :key="index" :value="item.platformname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品类:">
          <el-select v-model="formData.detailCategory" filterable placeholder="全部" @change="onSearch">
            <el-option label="全部" value="" />
            <el-option v-for="(item, index) in detailCategoryList" :label="item" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="!isShowProductSales">
          <el-form-item label="销售等级:">
            <el-select v-model="formData.saleGrade" filterable placeholder="全部" @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="(item, index) in saleGradeList" :label="item" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="滞销等级:">
            <el-select v-model="formData.unsalableLevel" filterable placeholder="全部" @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="(item, index) in unsalableLevelList" :label="item" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺:">
            <el-select v-model="formData.storeCode" filterable multiple collapse-tags>
              <el-option label="全平台" value="" />
              <el-option v-for="(item, index) in useObjectList" :label="item.name" :key="index" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品生命周期:">
            <el-select v-model="formData.proStateList" multiple collapse-tags placeholder="全部">
              <el-option v-for="(item, index) in proStateList" :label="item.label" :key="index" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否新品:">
            <el-select v-model="formData.isNew" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="是" value="Y" />
              <el-option label="否" value="N" />
            </el-select>
          </el-form-item>
          <span class="form-date-picker">
            <el-form-item label="付款时间:">
              <form-date-range :form="formData" startKey="planTimeStart" :usingTime="false" endKey="planTimeEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
            </el-form-item>
          </span>
          <span class="form-date-picker">
            <el-form-item label="上市时间:">
              <form-date-range :form="formData" startKey="marketOnStart" :usingTime="false" endKey="marketOnEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
            </el-form-item>
          </span>
          <el-form-item label="监控品:">
            <el-select v-model="formData.monitorFlag" filterable placeholder="全部" @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="(item, index) in monitorFlagList" :label="item.label" :key="index" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额/销量:">
            <el-checkbox-group v-model="formData.searchType" @change="onSearch">
              <el-checkbox label="2" v-if="columnJurisdiction" :disabled="formData.searchType.length == 1 && formData.searchType[0] == '2'">金额</el-checkbox>
              <el-checkbox label="1" :disabled="!columnJurisdiction || (formData.searchType.length == 1 && formData.searchType[0] == '1')">销量</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
        <template v-else>
          <span class="form-date-picker">
            <el-form-item label="上市时间:">
              <form-date-range :form="formData" startKey="marketOnStart" :usingTime="false" endKey="marketOnEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
            </el-form-item>
          </span>
        </template>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="onExport">导出</el-button>
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
      </template>
      <el-table
        ref="tableRef"
        border
        stripe
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData"
        :height="maxTableHeight"
        @sort-change="handleSortChange"
        v-loading="loading"
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width"
          :fixed="item.fixed"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          v-for="(item, index) in columnData"
          :key="index"
        >
          <template slot="header">
            <template v-if="item.label.includes('销量')">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">包含京东入仓销量</div>
              </el-tooltip>
            </template>
            <template v-else-if="item.label.includes('滞销持续天数')">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">指变为滞销款到今天的天数</div>
              </el-tooltip>
            </template>
            <template v-else-if="item.label == '净库存'">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">销售公司可用库存-未交总量</div>
              </el-tooltip>
            </template>
            <template v-else-if="item.label == '净总量'">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">销售净可用库存+在制(配套)+未排(配套)+余备料(配套)</div>
              </el-tooltip>
            </template>
            <template v-else-if="item.label.includes('净库存可销售天数')">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">产品净库存量/近90天日均销量</div>
              </el-tooltip>
            </template>
            <template v-else-if="item.label.includes('净总量预计可销售天数')">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">产品净总量/90的日均销量</div>
              </el-tooltip>
            </template>
          </template>
          <template slot-scope="scope">
            <template v-if="item.label === '图片'">
              <template v-if="showDetailBtn(scope.row)">
                <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
              </template>
            </template>
            <el-link
              type="primary"
              :underline="false"
              @click="viewSales(scope, '销量')"
              v-else-if="
                (item.label.includes('销量') || item.label == '合计') &&
                !formData.storeCode.length &&
                item.label != '月均销量' &&
                !item.label.includes('同比') &&
                scope.row[item.prop] && 
                scope.row[item.prop] > 0
              "
              >{{ scope.row[item.prop] }}</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              @click="viewSales(scope, '金额')"
              v-else-if="(item.label.includes('金额') || item.label.includes('销售额合计')) && !item.label.includes('同比') && scope.row[item.prop] && scope.row[item.prop] > 0"
              >{{ scope.row[item.prop] }}</el-link
            >
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <div>
            <span>{{ timeText.updateContent ? '数据刷新时间：' : '' }}</span>
            <span>{{ timeText.latestUpdateTime ? timeText.latestUpdateTime : '' }}</span>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="paginationOpt.pageNum"
              :page-sizes="paginationOpt.pageSizes"
              :page-size="paginationOpt.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="paginationOpt.total"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </table-panel>
    <el-dialog :visible.sync="recordDialogVisible" title="销量情况" width="45%">
      <div>
        <el-table
          :data="recordData"
          v-loading="loading2"
          border
          :height="300"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
          }"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
        >
          <el-table-column prop="storeName" label="店铺"></el-table-column>
          <el-table-column prop="sale" label="销量" v-if="isShowNumName == '销量'"></el-table-column>
          <el-table-column prop="saleAmount" label="销售金额" v-else></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>
    <!-- 自定义列 -->
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
  </div>
</template>

<script>
import importExportMxin from './import&export.mixin';
import picVideoMxin from './pic&video.mixin';
import moment from 'moment';
import customPropsMixin from './customProps.mixin';
import tableMixin from '@/utils/tableMixin';
import axios from '@/utils/axiosInstance';
export default {
  name: 'ProductSales',
  mixins: [importExportMxin, customPropsMixin, picVideoMxin, tableMixin],
  components: {},
  data() {
    return {
      tableHeight: 0,
      loading: false,
      loading2: false,
      formData: {
        storeCode: [],
        proState: '',
        detailCategory: '',
        saleGrade: '',
        unsalableLevel: '',
        platformName: [],
        planTimeStart: moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD'),
        planTimeEnd: moment(new Date()).subtract('months').format('YYYY-MM-DD'),
        sortOptions: '',
        sortField: '',
        monitorFlag: '',
        searchType: [],
        isNew: '',
      },
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      exportData: {},
      columnsData: [],
      recordDialogVisible: false,
      recordData: [],
      timeText: {},
      isShowNumName: '',
      thisYear: moment().format('YYYY'),
      useObjectList: [],
      detailCategoryList: [],
      saleGradeList: [],
      unsalableLevelList: [],
      proStateList: [],
      platformNameList: [],
      columnJurisdiction: true,
      header_H: '38px',
      reportCode: 'productSaleInfo',
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
      monitorFlagList: [
        {
          label: '是',
          value: 'Y',
        },
        {
          label: '否',
          value: 'N',
        },
      ],
    };
  },
  computed: {
    permitList() {
      return JSON.parse(localStorage.getItem('permitList'));
    },
    isShowProductSales() {
      let Jurisdiction = 'ec-pc-new$reportCenter$productSalesData$productSalesData$productSales';
      return this.permitList.includes(Jurisdiction);
    },
  },
  watch: {
    $route: {
      handler(val, olv) {
        if (olv.path == '/keyProductMonitoring' && val.query.bigModel != this.formData.productBigModel && JSON.stringify(val.query) != '{}') {
          let { bigModel } = val.query || {};
          this.$set(this.formData, 'productBigModel', bigModel || '');
          this.$set(this.formData, 'monitorFlag', bigModel ? 'Y' : '');
          this.buttonJurisdiction();
          this.getProState();
          this.getDetailCategory();
          this.getSaleGrade();
          this.getUnsalableLevel();
          this.$set(this.formData, 'searchType', this.columnJurisdiction ? ['1', '2'] : ['1']);
          this.onSearch();
        }
      },
    },
  },
  mounted() {
    let { bigModel } = this.$route.query || {};
    this.$set(this.formData, 'productBigModel', bigModel || '');
    this.$set(this.formData, 'monitorFlag', bigModel ? 'Y' : '');
    this.buttonJurisdiction();
    this.getProState();
    this.getDetailCategory();
    this.getSaleGrade();
    this.getUnsalableLevel();
    this.$set(this.formData, 'searchType', this.columnJurisdiction ? ['1', '2'] : ['1']);
    this.$set(this.formData, 'planTimeStart', !this.isShowProductSales ?  moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD') : moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'),);
    this.$set(this.formData, 'proStateList', !this.isShowProductSales ? ['投产新品', '上市新品', '常规在产'] : []);
    this.refreshTime();
    this.getPlatformName();
    this.onSearch();
  },
  methods: {
    handleSearch(data) {
      if (this.$refs['tableRef']) {
        this.$refs['tableRef'].clearSort(); //切换清除排序
        this.orderDto = {};
      }
      this.paginationOpt.pageNum = 1;
      this.formData = data;
      this.init();
    },
    viewSales(scope, type) {
      this.recordData = [];
      this.recordDialogVisible = true;
      this.loading2 = true;
      let formData = {
        productCode: scope.row.productCode,
        payMonth: scope.column.property,
        planTimeStart: this.formData.planTimeStart,
        planTimeEnd: this.formData.planTimeEnd,
        storeCodes: this.formData.storeCode || []
      };

      if (scope.row.productName === '合计') {
        const fields = ['productBigModel', 'productCode', 'productName']
        for (const [key, val] of Object.entries(this.formData)) {
          if (fields.includes(key) && typeof val !== 'undefined' && val !== null && val !== '') {
            formData[key] = val
          }
        }
      }

      let interFace = type == '销量' ? this.$q.commoditySales.productStoreSales : this.$q.commoditySales.storeSalesAmount;
      this.isShowNumName = type;
      interFace({ data: formData })
        .then((res) => {
          if (res.data.length && res.code == 200) {
            console.log(res);
            this.recordData = res.data;
          } else {
            this.recordData = [];
          }
        })
        .finally((_) => {
          this.loading2 = false;
        });
    },
    init(type) {
      this.loading = true;
      let formData = {
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
          ...this.orderDto,
          storeCode: this.formData.storeCode && this.formData.storeCode.length ? this.formData.storeCode.join(',') : ''
        },
      };
      formData.filterData.searchType = formData.filterData.searchType.length == 2 ? 0 : formData.filterData.searchType[0];
      this.exportData = formData;
      this.$q.commoditySales
        .salesSearch({ data: formData })
        .then((res) => {
          if (res.code == 200) {
            if (!type) {
              this.pagingColumnData = res.data.titleList;
              this.customColumn();
            }
            this.tableData = res.data.records;
            this.paginationOpt['total'] = res.data.total;
          } else {
            this.tableData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init(1);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init(1);
    },
    buttonJurisdiction() {
      this.$q.user.authListUserButton({ params: { subAppCode: 'ec-pc-new' } }).then(({ data }) => {
        // 将权限列表写入local
        let Jurisdiction = 'ec-pc-new$reportCenter$productSalesData$productSalesData$Sales';
        this.columnJurisdiction = data.includes(Jurisdiction);
      });
    },
    onSearch() {
      this.salesGetStore();
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    onReset() {
      this.$refs.tableRef.clearSort()
      this.formData = {
        storeCode: [],
        proStateList: !this.isShowProductSales ? ['投产新品', '上市新品', '常规在产'] : [],
        detailCategory: '',
        saleGrade: '',
        unsalableLevel: '',
        platformName: [],
        planTimeStart: !this.isShowProductSales ?  moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD') : moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'),
        planTimeEnd: moment(new Date()).subtract('months').format('YYYY-MM-DD'),
        searchType: this.columnJurisdiction ? ['1', '2'] : ['1'],
        monitorFlag: '',
        isNew: '',
      };
      this.$nextTick((_) => {
        this.onSearch();
      });
    },
    salesGetStore() {
      const params = {
        params: {
          planTimeStart: this.formData.planTimeStart,
          planTimeEnd: this.formData.planTimeEnd,
        },
      };
      this.$q.commoditySales.productSalesGetStore(params).then((res) => {
        this.useObjectList = res.data;
      });
    },
    onCollapse() {
      this.collapse = !this.collapse;
      if (this.collapse) {
        this.header_H = 'auto';
      } else {
        this.header_H = '38px';
      }
    },
    //产品生命周期
    getProState() {
      let data = { ...this.currencyForm };
      data.reportCode = 'commonProductStateList';
      axios.post(`/ec-pc-api/custom/reports/data/commonProductStateList`, data).then((res) => {
        if (res.code == 200) {
          this.proStateList = res.data.list.map((v) => {
            return {
              ...v,
              value: v.proState,
              label: v.proStateDesc,
            };
          });
        }
      });
    },
    //品类
    getDetailCategory() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = 'detailCategory';
      data.reportCode = this.reportCode;
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.detailCategoryList = data;
        this.detailCategoryList = this.detailCategoryList.filter((v) => v != '(空白)');
      });
    },
    //销售等级
    getSaleGrade() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = 'saleGrade';
      data.reportCode = this.reportCode;
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.saleGradeList = data.sort((a, b) => {
          return a.charCodeAt(a.length - 2) - b.charCodeAt(b.length - 2);
        });
        this.saleGradeList = this.saleGradeList.filter((v) => v != '(空白)');
      });
    },
    //中文数字转换成数字
    convert(str) {
      var arr = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
      for (var i = 0; i < arr.length; i++) {
        str = str.replace(new RegExp(arr[i], 'g'), i + 1);
      }
      return str;
    },
    //滞销等级
    getUnsalableLevel() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = 'unsalableLevel';
      data.reportCode = this.reportCode;
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.unsalableLevelList = data.sort((a, b) => {
          let x = a.charAt(0);
          let y = b.charAt(0);
          return this.convert(x) - this.convert(y);
        });
        this.unsalableLevelList = this.unsalableLevelList.filter((v) => v != '(空白)');
      });
    },
    handleSortChange({ column, prop, order }) {
      this.paginationOpt.pageNum = 1;
      this.orderDto = {
        sortField: prop,
        sortOptions: order === 'ascending' ? '0' : order === 'descending' ? '1' : '',
      };
      this.init(1);
    },
    // 平台名称
    getPlatformName() {
      let data = { ...this.currencyForm };
      data.reportCode = 'platformNameQuery';
      axios.post(`/ec-pc-api/custom/reports/data/platformNameQuery`, data).then((res) => {
        if (res.code == 200) {
          this.platformNameList = res.data.list;
        }
      });
    },
    async refreshTime() {
      let res = await this.$q.common.refreshTime({ fragment: [53] });
      this.timeText = res.data;
    },
  },
};
</script>
<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
.footerBox
  display flex
  justify-content space-between
  align-items center
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
